import React, { useEffect, useContext } from 'react'
import PropTypes from 'prop-types'

import { makeStyles } from "@material-ui/core/styles"
import UserMeContext from "components/UserMeContext"
import WinterLoading from 'components/WinterLoading'
import ChristmasDecorations from 'components/ChristmasDecorations'
import SettingsContext from 'modules/settings/context'
import { findOnArray } from 'reacticoon/utils/array'
import SecurityManager from 'modules/security/SecurityManager'
import isEmpty from 'lodash/isEmpty'
import { getQueryParam, Query } from 'reacticoon/routing'
import { compose } from 'reacticoon/view'
import classNames from 'classnames'
import useAddFlashMessage from 'reacticoon-plugin-flash-messages/useAddFlashMessage'
import useMountEffect from 'reacticoon/view/hook/useMountEffect'
import { Link, getRoute } from 'reacticoon/routing'
import { findIndexOnArray } from 'reacticoon/utils/array'
import useStorageState from 'reacticoon/view/hook/useStorageState'
import useIsMobile from 'components/useIsMobile'
import { withStyles, withTheme } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import Drawer from '@material-ui/core/Drawer'
import Box from '@material-ui/core/Box'
import MessageBlock from 'components/MessageBlock'
import Toolbar from '@material-ui/core/Toolbar'
import AppBar from '@material-ui/core/AppBar'
import Paper from '@material-ui/core/Paper'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import { Helmet } from 'reacticoon-plugin-helmet/'
import RouteContext from 'reacticoon/archi/components/RouteContext'
import AuthContext from 'modules/auth/context'
import UserMeContainer from 'modules/userMe/container'
import LoadingBlock from 'app/components/LoadingBlock'
import LoadingPage from 'components/loading/LoadingPage'
import RoutingContainer from 'reacticoon/routing/RoutingContainer'
import ButtonLink from 'components/ButtonLink'
import useCommand from 'components/useCommand'
import ButtonLoading from 'components/ButtonLoading'
import Header from './Header'
import Sidebar from './Sidebar'

const styles = (theme) => ({
  root: {
    display: 'flex',
    flex: 1,
    height: '100vh',
  },
  toolbar: {
    [theme.breakpoints.up('sm')]: {
      paddingRight: 24, // keep right padding when drawer closed
    },
    minHeight: theme.app.header.height,
  },
  appBar: {
    height: theme.app.header.height,
    // [theme.breakpoints.up('md')]: {
    //   width: `calc(100% - ${theme.app.sidebar.width}px)`,
    // },
    background: theme.app.background.dark,

    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: theme.app.sidebar.width,
    width: `calc(100% - ${theme.app.sidebar.width}px)`,
    [theme.breakpoints.down('sm')]: {
      width: `100%`
    },
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: theme.app.sidebar.width,
    [theme.breakpoints.down('sm')]: {
      width: `100vw`
    },
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: theme.app.background.dark,
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 0,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  appBarSpacerWithTabs: {
    // ...theme.mixins.toolbar,
    height: 40,
    minHeight: 40,
  },
  appBarSpacerContentFull: {
    minHeight: theme.app.header.height,
    height: theme.app.header.height,
  },
  content: {
    ...theme.style.scrollbar,

    flexGrow: 1,
    // ⚠️ LE point de débordement horizontal de tout le site.
    //
    // `content` est l'enfant flex qui porte TOUTES les pages, dans un `root` en ligne
    // (display:flex). Or la valeur par défaut de `min-width` sur un élément flex est `auto` :
    // il refuse de descendre sous la largeur intrinsèque de son contenu. Un seul tableau
    // large, un identifiant sans espace ou une rangée de cartes suffisait donc à pousser la
    // zone de contenu au-delà de la fenêtre — sur n'importe quelle page.
    //
    // Le `body { overflow-x: hidden }` de mobile-responsive-helpers.css masquait le
    // symptôme : au lieu d'une barre de défilement, le contenu était simplement COUPÉ et
    // devenait inatteignable. C'est ce qu'on voit sur les captures.
    minWidth: 0,
    height: '100vh',
    overflow: 'auto',
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0),
    },
  },
  removeBottomPadding: {
    paddingBottom: 0,
  },
  contentFull: {
    padding: 0,
    overflow: 'hidden',
  },
  loading: {},
  
  announcementWarningMessage: {
    backgroundColor: theme.status.warning,
    padding: theme.spacing(0.5),
    color: 'rgba(107, 114, 128, 1)',

    '& .MuiButton-root': {
      marginLeft: theme.spacing(1),
    },
  },
  announcementInfoMessage: {
    backgroundColor: theme.status.info,
    padding: theme.spacing(2),
  },
  contentWithAnnouncement: {
    marginTop: theme.spacing(10),
  },
  contentWithIsViewingSomeoneElse: {
    marginTop: theme.spacing(10),
  }
})

const UserMe = ({ isLoggedIn, children }) =>
  isLoggedIn ? <UserMeContainer>{children}</UserMeContainer> : children({ me: null })


  const useTabsViewStyles = makeStyles(theme => ({

    tabsPaper: {
      marginTop: theme.spacing(2),
      width: '100%',
      padding: theme.spacing(0),
      background: theme.palette.background.paper,
      display: 'flex',
      justifyContent: 'space-between',
      borderRadius: '12px',
      overflow: 'hidden',

      '& .MuiInputBase-root': {
        marginTop: 0,
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(0.4),
      },
  
      [theme.breakpoints.down('sm')]: {
        margin: 0,
        marginTop: theme.app.header.height,
        fontSize: 12
      },
      [theme.breakpoints.up('sm')]: {
        // marginLeft: theme.spacing(2),
        // marginRight: theme.spacing(2),
      },
  
      '& .MuiTabs-root': {
        flex: 1,
        // ⚠️ Sans `minWidth: 0`, la barre d'onglets ne rétrécit jamais sous la largeur de
        // ses onglets : MUI ne détecte donc AUCUN débordement et n'affiche pas les flèches
        // de défilement, pendant que le `overflow: hidden` de `tabsPaper` tronque la fin.
        // C'est pour ça que `variant="scrollable"` semblait sans effet.
        minWidth: 0,
        ...theme.style.scrollbar,
        height: 32,
        maxHeight: 32,
        minHeight: 32,
        [theme.breakpoints.down('sm')]: {
          minHeight: 30,
          height: 30,
        },
      },
  
      '& .MuiTab-root': {
        height: 32,
        maxHeight: 32,
        minHeight: 32,
        [theme.breakpoints.down('sm')]: {
          minHeight: 30,
          height: 30,
          padding: `3px 6px`
        },
      },
    },
  
    tabsRoot: {
      [theme.breakpoints.down('sm')]: {
        minHeight: 40,
        height: 40,
      },
  
    },
    tabsFlexContainer: {
      // overflowX: 'auto',
    },
  }))

  function TabsView({
    tabsConfig,
    route,
  }) {
  const classes = useTabsViewStyles()
  const [anchorEls, setAnchorEls] = React.useState({})

  if (!tabsConfig) {
    return null
  }

  const handleClick = (event, tabLabel) => {
    setAnchorEls({ ...anchorEls, [tabLabel]: event.currentTarget })
  }

  const handleClose = (tabLabel) => {
    setAnchorEls({ ...anchorEls, [tabLabel]: null })
  }

  // Fonction pour trouver si une route est dans les sous-tabs
  const isRouteInSubTabs = (tabs, routeName) => {
    if (!tabs) return false
    return tabs.some(tab => {
      if (tab.route === routeName) return true
      if (tab.tabs) return isRouteInSubTabs(tab.tabs, routeName)
      return false
    })
  }

  return (
    <React.Fragment>
      <Paper square className={classes.tabsPaper}>

        {tabsConfig.leftView && tabsConfig.leftView()}

        <Tabs
          classes={{ root: classes.tabsRoot, flexContainer: classes.tabsFlexContainer }}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          // ⚠️ Sans cette prop, MUI applique `scrollButtons="auto"`, qui MASQUE les flèches
          // en dessous du palier `sm` — les onglets se retrouvaient coupés au bord de l'écran
          // sans le moindre indice qu'il en restait d'autres. `"on"` les affiche toujours.
          scrollButtons="on"
          value={false}
        >
          {tabsConfig.tabs.map((tab, index) => {
            const hasSubTabs = tab.tabs && tab.tabs.length > 0
            const isActive = tab.route === route?.name || (hasSubTabs && isRouteInSubTabs(tab.tabs, route?.name))
            
            if (hasSubTabs) {
              // Tab avec dropdown
              return (
                <React.Fragment key={`tab-${tab.label}-${index}`}>
                  <Tab
                    className={classes.tab}
                    label={
                      <Box display="flex" alignItems="center">
                        {tab.label}
                        <ArrowDropDownIcon style={{ marginLeft: 4 }} />
                      </Box>
                    }
                    onClick={(e) => handleClick(e, tab.label)}
                    style={{
                      color: isActive ? '#2196f3' : 'inherit',
                      borderBottom: isActive ? '2px solid #2196f3' : 'none',
                    }}
                  />
                  <Menu
                    anchorEl={anchorEls[tab.label]}
                    open={Boolean(anchorEls[tab.label])}
                    onClose={() => handleClose(tab.label)}
                  >
                    {tab.tabs.map((subTab) => (
                      <MenuItem
                        key={`subtab-${subTab.route}`}
                        component={Link}
                        to={subTab.route}
                        params={subTab.routeParams}
                        query={subTab.routeQuery}
                        onClick={() => handleClose(tab.label)}
                        selected={subTab.route === route?.name}
                      >
                        {subTab.label}
                      </MenuItem>
                    ))}
                  </Menu>
                </React.Fragment>
              )
            } else {
              // Tab normal
              return (
                <Tab
                  key={`tab-${tab.label}-${index}`}
                  component={Link}
                  label={tab.label}
                  className={classes.tab}
                  to={tab.route}
                  params={tab.routeParams}
                  query={tab.routeQuery}
                  style={{
                    color: isActive ? '#2196f3' : 'inherit',
                    borderBottom: isActive ? '2px solid #2196f3' : 'none',
                  }}
                />
              )
            }
          })}
        </Tabs>

      </Paper>
      <Box mb={2} />
    </React.Fragment>
  )
}

function Children({
  route,
  routeParams,
  isPending,
  loadingMessage,
  children,
  tabsConfig,
}) {

  if (route?.authRequired) {
    return (
      <>
        {isPending
          ? <LoadingPage show message={loadingMessage} />
          : <>
            <TabsView
              route={route}
              tabsConfig={tabsConfig}
            />
            {children}
          </>
        }
      </>
    )
  }


  return (
    <>
      <Tabs
        tabsConfig={tabsConfig}
        route={route}
      />
      {isPending ? <LoadingPage show message={loadingMessage} /> : children}
    </>
  )

}

const Page = ({
  isFullPage,
  isPending = false,
  // remove padding on content
  isContentFull = false,
  loadingMessage,
  title,
  session,
  route,
  redirectTo,
  updatePageQueries,
  classes,
  children,
  routeParams,
  // remove the bottom padding on the content, use it to make a dashboard with its own scroll
  removeBottomPadding = false,
  getTabsConfig = null,
  tabsConfigParams,
}) => {
  const [isGameMode] = useStorageState('isGameMode', false)
  const [sidebarIsOpen, setSidebarIsOpen] = useStorageState('sidebarIsOpen', true)
  const [sidebarClosedByUser, setSidebarClosedByUser] = useStorageState('sidebarClosedByUser', false)
  const isMobile = useIsMobile()
  const { addSuccessFlashMessage, addErrorFlashMessage } = useAddFlashMessage()
  // const [snowEnabled, _] = useStorageState('snowEnabled', true)

  // Fermer automatiquement la sidebar sur mobile quand la fenêtre se réduit
  // Mais seulement si l'utilisateur ne l'a pas fermée manuellement
  React.useEffect(() => {
    if (isMobile && sidebarIsOpen && !sidebarClosedByUser) {
      setSidebarIsOpen(false)
    }
    // Réouvrir sur desktop si elle n'a pas été fermée manuellement
    if (!isMobile && !sidebarIsOpen && !sidebarClosedByUser) {
      setSidebarIsOpen(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile])

  React.useEffect(() => {
    if (isGameMode) {
      // remove logs from the game console (f8)
      console.log = () => { }
      console.warn = () => { }
      console.debug = () => { }
      console.info = () => { }

      const handler = function (e) {
        if (e.ctrlKey) {
          e.preventDefault()
          return;
        }
      }

      const handlerMiddleClick = function (e) {
        e.preventDefault()
        return;
      }

      document.addEventListener('click', handler)
      document.addEventListener('auxclick', handlerMiddleClick)
      return () => {
        document.removeEventListener('click', handler)
        document.removeEventListener('auxclick', handlerMiddleClick)
      }
    }
  }, [isGameMode])

  useMountEffect(() => {
    const errorQueryParam = getQueryParam('error')
    if (!isEmpty(errorQueryParam)) {
      addErrorFlashMessage({
        text: errorQueryParam,
      })
      updatePageQueries({ error: Query.REMOVE_ME })
    }
  })

  const handleDrawerOpen = () => {
    setSidebarIsOpen(true)
    setSidebarClosedByUser(false) // L'utilisateur a ouvert manuellement
  }

  const handleDrawerClose = () => {
    setSidebarIsOpen(false)
    setSidebarClosedByUser(true) // L'utilisateur a fermé manuellement
  }

  if (route?.authRequired === true && !session?.isLoggedIn) {
    redirectTo('LOGIN')
  }

  if (route?.mustBeLogout === true && session?.isLoggedIn) {
    redirectTo('DASHBOARD')
  }

  const {
    runCommand: cancelViewAs,
    isPending: isCancelViewAsPending,
  } = useCommand({
    command: 'AUTH_VIEW_AS_STOP',
    manualRun: true,
    keepDataOnRequest: false,
    onSuccess: (response) => {
      addSuccessFlashMessage({
        text: `Vous avez arrêté de visualiser TASEv3 en tant qu'un autre joueur`,
        data: response.message
      })
      window.location.reload()
      //window.location.replace(window.location.protocol + "//" + window.location.host + "/")
    },
    onFailure: (error) => {
      addErrorFlashMessage({
        text: error?.message || `Erreur lors de l'arrêt de la visualisation en tant qu'un autre joueur`,
        data: error,
      })
    },
  })


  // Get active theme from settings
  const settings = useContext(SettingsContext)
  const activeThemeSetting = findOnArray(settings || [], setting => setting.name === 'activeTheme')
  const activeTheme = activeThemeSetting?.value || 'default'

  return (
    <div className={classes.root}>
      <CssBaseline />

      <ChristmasDecorations activeTheme={activeTheme} />

      {/* TODO: titleTemplate does not work. cf RconList */}
      <Helmet titleTemplate="%s - TASEv3" defaultTitle={`${title || '-'} - TASEv3`}>
        <title>{`${title || '-'} - TASEv3`}</title>
      </Helmet>

      {/* TODO: loading in middle of the page */}
      <UserMe isLoggedIn={session?.isLoggedIn}>
        {({ data: me, error: userMeError }) => (
          <PageMe
            route={route}
            handleDrawerClose={handleDrawerClose}
            me={me}
            isMobile={isMobile}
            sidebarIsOpen={sidebarIsOpen}
            classes={classes}
            isContentFull={isContentFull}
            removeBottomPadding={removeBottomPadding}
            tabsConfigParams={tabsConfigParams}
            getTabsConfig={getTabsConfig}
            isGameMode={isGameMode}
            isFullPage={isFullPage}
            routeParams={routeParams}
            loadingMessage={loadingMessage}
            children={children}
            isCancelViewAsPending={isCancelViewAsPending}
            cancelViewAs={cancelViewAs}
            handleDrawerOpen={handleDrawerOpen}
            isPending={isPending}
            title={title}
            userMeError={userMeError}
          />
        )}
      </UserMe>
    </div>
  )
}

function PageMe({
  route,
  handleDrawerClose,
  me,
  isMobile,
  sidebarIsOpen,
  classes,
  isContentFull,
  removeBottomPadding,
  tabsConfigParams,
  getTabsConfig,

  isPending,
  title,
  userMeError,

  isGameMode,
  isFullPage,
  routeParams,
  loadingMessage,
  children,
  isCancelViewAsPending,
  cancelViewAs,
  handleDrawerOpen,
}) {
  const { setUserMe } = useContext(UserMeContext) 

  useEffect(() => {
    setUserMe(me)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me])

  if (me && !SecurityManager.hasPermission(route?.permissions || [])) {
    //return <p>Permissions required: {(route?.permissions || []).join(', ')}</p>
    return (
      <Box display="flex" alignItems="center" justifyContent="center" style={{ width: '100%' }}>
        <MessageBlock.Info text={`Permissions required: ${(route?.permissions || []).join(', ')}`} />
      </Box>
    )
  }

  if (userMeError) {
    //return <p>TASEv3 n'est pas accessible pour le moment. Veuillez réessayer plus tard.</p>
    return (
      <Box 
        display="flex" 
        alignItems="center" 
        justifyContent="center" 
        style={{ 
          width: '100%', 
          height: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        }}
      >
        <Box
          style={{
            background: 'rgba(255, 255, 255, 0.95)',
            borderRadius: '24px',
            padding: '48px 64px',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
            maxWidth: '600px',
            textAlign: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <Box
            style={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
              animation: 'pulse 2s ease-in-out infinite',
            }}
          >
            <span role="img" aria-label="lock" style={{ fontSize: 40 }}>🔒</span>
          </Box>
          <div style={{ 
            fontSize: '28px', 
            fontWeight: 700,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '16px',
          }}>
            TASEv3 est temporairement indisponible
          </div>
          <div style={{ 
            color: '#64748b', 
            fontSize: '16px',
            lineHeight: 1.6,
            marginBottom: '24px',
          }}>
            Il n'est probablement pas nécéssaire de prévenir qui que ce soit.<br />
            Néanmoins, si le problème persiste plus de 5 minutes, vous pouvez contacter un administrateur/fondateur.
          </div>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '12px 24px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '12px',
            color: 'white',
            fontSize: '14px',
            fontWeight: 600,
          }}>
            <span role="img" aria-label="timer" style={{ fontSize: 18 }}>⏱️</span>
            Veuillez réessayer dans quelques instants
          </div>
        </Box>
        <style>{`
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }
        `}</style>
      </Box>
    )
  }

  let tabsConfig = null
  if (getTabsConfig) {
    tabsConfig = getTabsConfig({ routeParams, tabsConfigParams, me, })
    
    // Fonction récursive pour filtrer les tabs selon les permissions
    const filterTabsByPermissions = (tabs) => {
      return (tabs || []).filter((tab) => {
        if (!tab) {
          return false
        }
        
        // Si le tab a une route, vérifier les permissions
        if (tab.route) {
          const route = getRoute(tab.route)
          return SecurityManager.hasPermission(route.permissions)
        }
        
        // Si le tab a des sous-tabs (catégorie), filtrer récursivement
        if (tab.tabs && tab.tabs.length > 0) {
          tab.tabs = filterTabsByPermissions(tab.tabs)
          // Garder la catégorie seulement si elle a au moins un sous-tab accessible
          return tab.tabs.length > 0
        }
        
        // Si ni route ni tabs, ne pas afficher
        return false
      })
    }
    
    tabsConfig.tabs = filterTabsByPermissions(tabsConfig.tabs)
  }

  return (
    /* loading me not found and page requires login */
    <LoadingBlock show={route?.authRequired && !me} className={classes.loading}>

      {!isFullPage && !isGameMode && (
        <AppBar
          position="absolute"
          className={classNames(classes.appBar, sidebarIsOpen && classes.appBarShift)}
        >
          <Toolbar disableGutters={!sidebarIsOpen} className={classes.toolbar}>
            <Header
              title={title}
              isLoggedIn={!!me}
              isMobile={isMobile}
              me={me}
              handleDrawerOpen={handleDrawerOpen}
              sidebarIsOpen={sidebarIsOpen}
              route={route}
            />
          </Toolbar>

          {me?.announcement && (
            <div
              style={{
                background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                padding: '16px 24px',
                boxShadow: '0 4px 12px rgba(79, 172, 254, 0.4)',
              }}
            >
              <Box display='flex' alignItems='center' style={{ gap: 16 }}>
                <Box
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backdropFilter: 'blur(10px)',
                  }}
                >
                  <span role="img" aria-label="announcement" style={{ fontSize: 20 }}>📢</span>
                </Box>
                <Box flex={1}>
                  <div style={{ 
                    color: 'white', 
                    fontWeight: 600, 
                    fontSize: '0.95rem',
                    lineHeight: 1.3,
                  }}>
                    Annonce
                  </div>
                  <div style={{ 
                    color: 'rgba(255, 255, 255, 0.95)', 
                    fontSize: '0.9rem',
                    marginTop: 4,
                    lineHeight: 1.5,
                  }}>
                    {me?.announcement}
                  </div>
                </Box>
              </Box>
            </div>
          )}

          {me?.isViewingSomeoneElse && (
            <div
              style={{
                background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                padding: '16px 24px',
                boxShadow: '0 4px 12px rgba(255, 107, 53, 0.4)',
                marginBottom: '24px',
              }}
            >
              <Box display='flex' justifyContent='space-between' alignItems='center'>
                <Box display='flex' alignItems='center' style={{ gap: 16 }}>
                  <Box
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: '50%',
                      background: 'rgba(255, 255, 255, 0.2)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backdropFilter: 'blur(10px)',
                    }}
                  >
                    <span role="img" aria-label="eye" style={{ fontSize: 20 }}>👁️</span>
                  </Box>
                  <Box>
                    <div style={{ 
                      color: 'white', 
                      fontWeight: 600, 
                      fontSize: '0.95rem',
                      lineHeight: 1.3,
                    }}>
                      Mode Visualisation
                    </div>
                    <div style={{ 
                      color: 'rgba(255, 255, 255, 0.85)', 
                      fontSize: '0.85rem',
                      marginTop: 2,
                    }}>
                      Vous visualisez TASEv3 avec les permissions de <strong>{me?.gamePlayer?.fullName}</strong>
                    </div>
                  </Box>
                </Box>
                <Box display='flex' style={{ gap: 12 }}>
                  <ButtonLink 
                    to="PLAYER" 
                    params={{ identifier: me?.isViewingIdentifier }}
                    variant="contained"
                    size="small"
                    style={{
                      background: 'rgba(255, 255, 255, 0.95)',
                      color: '#ff6b35',
                      fontWeight: 600,
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                      '&:hover': {
                        background: 'white',
                      }
                    }}
                  >
                    Voir le profil
                  </ButtonLink>
                  <ButtonLoading
                    size="small"
                    variant="contained"
                    style={{
                      background: 'rgba(244, 67, 54, 0.9)',
                      color: 'white',
                      fontWeight: 600,
                      boxShadow: '0 2px 8px rgba(244, 67, 54, 0.3)',
                    }}
                    onClick={() => cancelViewAs()}
                    isPending={isCancelViewAsPending}
                  >
                    <DeleteForeverIcon style={{ marginRight: 6 }} />
                    Quitter
                  </ButtonLoading>
                </Box>
              </Box>
            </div>
          )}
        </AppBar>
      )}

      {!isFullPage && !isGameMode && (
        <Drawer
          variant={isMobile ? "temporary" : "permanent"}
          classes={{
            paper: classNames(
              classes.drawerPaper,
              !sidebarIsOpen && classes.drawerPaperClose
            ),
          }}
          open={sidebarIsOpen}
          onClose={handleDrawerClose}
        >
          <Sidebar
            route={route}
            routeParams={routeParams}
            tabsConfigParams={tabsConfigParams}
            onClose={handleDrawerClose}
            isMobile={isMobile}
            sidebarIsOpen={sidebarIsOpen}
          />
        </Drawer>
      )}

      <main
        className={classNames(classes.content, {
          [classes.contentFull]: isContentFull,
          [classes.removeBottomPadding]: removeBottomPadding
        })}
        dataroute={route?.name}
      >
        {!isFullPage && (
          <div
            className={classNames({
              [classes.appBarSpacer]: !isGameMode,
              [classes.appBarSpacerContentFull]: isContentFull,
              [classes.appBarSpacerWithTabs]: !!tabsConfig && !isGameMode,
              [classes.contentWithAnnouncement]: me?.announcement,
              [classes.contentWithIsViewingSomeoneElse]: me?.isViewingSomeoneElse
            })}
          />
        )}

        {route?.authRequired && !me && <WinterLoading />}

        <Children
          route={route}
          routeParams={routeParams}
          tabsConfigParams={tabsConfigParams}
          me={me}
          isPending={isPending}
          loadingMessage={loadingMessage}
          children={children}
          tabsConfig={tabsConfig}
        />
      </main>
    </LoadingBlock>
  )
}

Page.propTypes = {
  classes: PropTypes.object.isRequired,
}

const PageContext = ({ children, ...props }) => (
  <AuthContext.Consumer>
    {(session) => (
      <RouteContext.Consumer>
        {({ route }) => (
          <RoutingContainer>
            {({ redirectTo, updatePageQueries }) => (
              <Page
                {...props}
                session={session}
                route={route}
                redirectTo={redirectTo}
                updatePageQueries={updatePageQueries}
              >
                {children}
              </Page>
            )}
          </RoutingContainer>
        )}
      </RouteContext.Consumer>
    )}
  </AuthContext.Consumer>
)

export default compose(withStyles(styles), withTheme)(PageContext)
